import {
  LocalHostname,
  NonProductionDeployHostLabel,
} from '../constants/deployEnvironmentConstants';

const NON_PRODUCTION_HOST_LABELS = new Set<string>(
  Object.values(NonProductionDeployHostLabel)
);

const LOCAL_HOSTNAMES = new Set<string>(Object.values(LocalHostname));

function resolveHostname(hostname: string | undefined): string {
  if (hostname != null) return hostname;
  if (typeof window !== 'undefined') return window.location.hostname;
  return '';
}

/**
 * True when the PHA work (MHA, PHA, Service Member, Record Reviewer, Commander,
 * Workflow Queue) is enabled. Off unless `VITE_ENABLE_PHA_WORK=true` (work paused).
 * When off, the exam-card actions are hidden and the routes fall through to Not Found.
 */
export function isPhaWorkEnabled(): boolean {
  return import.meta.env.VITE_ENABLE_PHA_WORK === 'true';
}

/**
 * True when exam-card preview portal actions should show
 * (Service Member, Record Reviewer, MHA & PHA Review, Commander Readiness,
 * High Level Commander). Off unless `isPhaWorkEnabled()`.
 * When on: local Vite (`import.meta.env.DEV`), localhost, and Dev/Staging DNS labels
 * (e.g. hcp.dev.healthesus.com, hcp.stg.healthesus.com) are allowed.
 * Production and other hosts hide the actions for everyone.
 */
export function areExamPreviewPortalActionsEnabled(
  hostname?: string,
  isViteDev: boolean = import.meta.env.DEV,
  isPhaEnabled: boolean = isPhaWorkEnabled()
): boolean {
  if (!isPhaEnabled) return false;
  if (isViteDev) return true;
  const normalized = resolveHostname(hostname).trim().toLowerCase();
  if (LOCAL_HOSTNAMES.has(normalized)) return true;
  const labels = normalized.split('.').filter((part) => part.length > 0);
  return labels.some((label) => NON_PRODUCTION_HOST_LABELS.has(label));
}
